import os from '@edu-fe/os'
import api from '@edu-fe/api'
import login from '@/utils/login'
import * as get from '@ccforeverd/tool-get'

import utils from './api.utils'

import mine from './api.mine'
import recommend from './api.recommend'
import course from './api.course'
import categroy from './api.category'
import freeVideo from './api.free_video'
import signUp from './api.sign-up'
import schedule from './api.schedule'
import share from './api.share'
import media from './api.media'
import wealth from './api.wealth'
import gift from './api.gift'
import pay from './api.pay'
import today from './api.today'
import live from './api.live'
import privilege from './api.privilege'
import distribution from './api.distribution'
import clockIn from './api.clock-in'
import group from './api.group'
import daily from './api.daily'
import getRead from './api.get-read'
import preferential from './api.preferential'
import activity from './api.activity'
import custom from './api.custom'
import authentication from './api.authentication'
import wpsTemplate from './api.wpsTemplate'
import superPaper from './api.paper'
import exchange from './api.exchange'
import free from './api.free'
import present from './api.present'
import recharge from './api.recharge'
import diversion from './api.diversion'
import mediaCourse from './api.mediaCourse'

let wpsSidCache = ''
let loginTokenCache = ''
let loginTokenInvoked = false
const wpsSidPromise = login.getWpsSid()
const appendQuery = (target, key, value) => {
  if (value) {
    target[key] = value
  }
}

api.use(async (options, next) => {
  try {
    return wpsSidPromise.then(async wpsSid => {
      wpsSid = wpsSid || wpsSidCache
      options.params = options.params || {}
      wpsSidCache = wpsSid

      // 1. 目前 api 的配置聚合方式有问题，所以先用正则进行简单判断是否自带 wpsSid
      // 2. login.getWpsSid 有可能会返回 loginToken, 以 'loginToken=' 开头
      if (!/wpsSid=/.test(options.url) && wpsSid.indexOf('loginToken=') === -1) {
        appendQuery(options.params, 'userId', wpsSid)
      }

      if (!loginTokenInvoked) {
        loginTokenInvoked = true
        if (os.sdk && os.sdk.user && os.sdk.user.getToken) {
          loginTokenCache = await os.sdk.user.getToken()
        }
      }

      appendQuery(options.params, 'loginToken', get.data.loginToken || loginTokenCache)
      appendQuery(options.params, 'channel', get.data.channel)
      appendQuery(options.params, 'from', get.query()['order_from'] || get.query().from)

      return next()
    })
  } catch (e) {
    console.log(e)
  }
})

api._requestOptions.baseURL = 'https://course.auoktalk.com/api'

// api._requestOptions.baseURL = 'http://localhost:9127'

api.createModule(utils, utils.name)

api.createModule(mine, mine.name)
api.createModule(recommend, recommend.name)
api.createModule(course, course.name)
api.createModule(categroy, categroy.name)
api.createModule(freeVideo, freeVideo.name)
api.createModule(signUp, signUp.name)
api.createModule(schedule, schedule.name)
api.createModule(share, share.name)
api.createModule(media, media.name)
api.createModule(wealth, wealth.name)
api.createModule(gift, gift.name)
api.createModule(pay, pay.name)
api.createModule(today, today.name)
api.createModule(live, live.name)
api.createModule(privilege, privilege.name)
api.createModule(distribution, distribution.name)
api.createModule(clockIn, clockIn.name)
api.createModule(group, group.name)
api.createModule(daily, daily.name)
api.createModule(getRead, getRead.name)
api.createModule(preferential, preferential.name)
api.createModule(activity, activity.name)
api.createModule(custom, custom.name)
api.createModule(authentication, authentication.name)
api.createModule(wpsTemplate, wpsTemplate.name)
api.createModule(superPaper, superPaper.name)
api.createModule(exchange, exchange.name)
api.createModule(free, free.name)
api.createModule(present, present.name)
api.createModule(recharge, recharge.name)
api.createModule(diversion, diversion.name)
api.createModule(mediaCourse, mediaCourse.name)
export default api
